define(
  'app/factories/enamad_factory',['app/setup', 'app/views/enamad_view'],
  function(takhfifan, enamadView) {
    $(function($) {
      /*
       * if ($('#enamad').length > 0) {
        new takhfifan.EnamadView({el:$('#enamad')});
      }
      */
    });
  }
);

